/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type AllPollParticipationQueryVariables = {||};
export type AllPollParticipationQueryResponse = {|
  +allPollsParticipants: ?{|
    +edges: $ReadOnlyArray<?{|
      +node: ?{|
        +answer: {|
          +id: string
        |}
      |}
    |}>
  |}
|};
export type AllPollParticipationQuery = {|
  variables: AllPollParticipationQueryVariables,
  response: AllPollParticipationQueryResponse,
|};
*/


/*
query AllPollParticipationQuery {
  allPollsParticipants {
    edges {
      node {
        answer {
          id
        }
        id
      }
    }
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": null,
  "concreteType": "PollChoicesNode",
  "kind": "LinkedField",
  "name": "answer",
  "plural": false,
  "selections": [
    (v0/*: any*/)
  ],
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "AllPollParticipationQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "PollParticipationNodeConnection",
        "kind": "LinkedField",
        "name": "allPollsParticipants",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "PollParticipationNodeEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "PollParticipationNode",
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                  (v1/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "AllPollParticipationQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "PollParticipationNodeConnection",
        "kind": "LinkedField",
        "name": "allPollsParticipants",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "PollParticipationNodeEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "PollParticipationNode",
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                  (v1/*: any*/),
                  (v0/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "3fc4c0d154de97f4d492786217d010de",
    "id": null,
    "metadata": {},
    "name": "AllPollParticipationQuery",
    "operationKind": "query",
    "text": "query AllPollParticipationQuery {\n  allPollsParticipants {\n    edges {\n      node {\n        answer {\n          id\n        }\n        id\n      }\n    }\n  }\n}\n"
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '14e1fba1a78bcf9fa0e62ad36215eb74';

module.exports = node;
